import { render } from "./LesProfesseursPage.vue?vue&type=template&id=1fac8a02"
import script from "./LesProfesseursPage.vue?vue&type=script&lang=js"
export * from "./LesProfesseursPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__